<template>
    <div class="text-center">
        <div id="paypal-button" v-show="!processing"></div>
        <div v-if="processing">
            <i class="fa fa-refresh fa-spin"></i> Processing PayPal transaction.
        </div>
    </div>
</template>

<script>
    import Order from '../../../Services/Order.js';
    import Checkout from '../../../Services/Checkout.js';

    export default {
        props: ['gatewayId', 'env'],
        data() {
            return {
                service: Order,
                processing: false,
            }
        },
        mounted() {
            this.$nextTick(() => {
               this.refresh();
            });

        },
        methods: {
            refresh() {
                const $this = this;
                let payload = $this.payload;
                paypal.Button.render({
                    env: this.getEnv(),
                    client: {
                        sandbox: $this.sandboxClientId,
                        production: $this.productionClientId,
                    },
                    commit: true,
                    style: {
                        label: 'buynow',
                        fundingicons: true, // optional
                        branding: true, // optional
                        size:  'large', // small | medium | large | responsive
                        shape: 'rect',   // pill | rect
                        color: 'blue'   // gold | blue | silver | black
                    },
                    payment(data, actions) {
                        return $this.setUpPayment(data, actions, payload);
                    },
                    onAuthorize(data, actions) {
                        return $this.authorize(data, actions);
                    }
                }, '#paypal-button');
            },
            setUpPayment(data, actions, payload) {
                this.$emit('start');
                return actions.payment.create({
                    transactions: [payload]
                });
            },
            /**
            * Handle Authorized payments
             */
            authorize(data, actions) {
                this.processing = true;
                return actions.payment.execute()
                .then(response => {
                    Checkout.setType('PayPal').process(
                        response.id,
                        null,
                        this.service.reference,
                        this.service.notes,
                        'paypal'
                    ).then(response => {
                        this.$emit('complete');
                    }).catch(errors => {
                        this.processing = false;
                        this.$emit('failed');
                    });
                }).catch(error => {
                    this.processing = false;
                    this.$emit('failed', true);
                });
            },
            getEnv() {
                if (this.env == 'live') {
                    return 'production';
                }
                return this.env;
            }
        },
        computed: {
            sandboxClientId() {
                return process.env.MIX_PAYPAL_SANDBOX_CLIENT_ID;
            },
            productionClientId() {
                return process.env.MIX_PAYPAL_LIVE_CLIENT_ID;
            },
            shipping() {
                return this.service.getShippingLine();
            },
            payload() {
                let order = this.service.order,
                    lines = _.filter(order.lines, line => {
                        return !line.is_shipping;
                    }),
                    shippingLines = _.filter(order.lines, line => {
                        return line.is_shipping;
                    });

                    let data = {
                        amount: {
                            total: order.order_total / 100,
                            currency: order.currency,
                            details: {
                                subtotal: order.sub_total / 100,
                                tax: order.tax_total / 100,
                                shipping: _.sumBy(shippingLines, 'line_total') / 100,
                                shipping_discount: -this.shipping.discount_total,
                            }
                        },
                        item_list: {
                            items: [],
                        }
                    };
                    // // Cannot get this to work properly due to weird unit quantities and PayPal
                    // // throwing a hissy fit.
                    // _.each(lines, line => {
                    //     data.item_list.items.push({
                    //         name: line.description,
                    //         quantity: line.quantity,
                    //         currency: order.currency,
                    //         sku: line.sku,
                    //     })
                    // });
                return data;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/PaypalGateway.vue